export const isMobileDevice = () => {
    return /Mobi/.test(navigator.userAgent);
  };